import React from 'react';

const Modal = ({ 
  isOpen, 
  onClose, 
  onConfirm,
  title, 
  message, 
  confirmText = 'OK',
  cancelText = 'Cancel',
  type = 'info',
  showCancel = false 
}) => {
  if (!isOpen) return null;
  
  // Debug logging
  if (title.includes('Required') || title.includes('missing')) {
    console.log('Modal Debug:', { title, showCancel, confirmText, cancelText, type });
  }


  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-black border border-[rgba(255,255,255,0.1)] rounded-lg p-6 w-full max-w-[400px] mx-4 max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-white text-[14px] font-medium">{title}</h2>
          <span
            onClick={onClose}
            className="text-white text-[12px] font-normal cursor-pointer hover:opacity-70"
          >
            Close
          </span>
        </div>

        {/* Content */}
        <div className="mb-6">
          <p className="text-[rgba(255,255,255,0.7)] text-[12px] leading-[1.4]">
            {message}
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end space-x-2 pt-4">
          {showCancel && (
            <button
              onClick={onClose}
              className="bg-[#121212] hover:bg-[#1a1a1a] text-white text-[12px] font-medium py-2 px-4 rounded-[8px] transition-colors focus:outline-none"
            >
              {cancelText}
            </button>
          )}
          <button
            onClick={handleConfirm}
            className="bg-[#FF3B30] hover:bg-[#e63329] text-white text-[12px] font-medium py-2 px-4 rounded-[8px] transition-all focus:outline-none"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;

